function PrimaryTabsContainer({ children }) {
  return <div>{children}</div>
}

export default PrimaryTabsContainer
